import { Api } from '@/services/Api'

export default {
  fetchZmuTableData(param,paramToggle) {
    return Api().post(`/api/v2/zmu/table/${paramToggle}`, param)
  },
  fetchZmuGraphData(param,paramToggle) {
    return Api().post(`/api/v2/zmu/graph/${paramToggle}`, param)
  },
}